export const LIMIT_PERIOD_YEARLY = "yearly";
export const LIMIT_PERIOD_YEARLY_LABEL = "Anual";
export const LIMIT_PERIOD_MONTHLY = "monthly";
export const LIMIT_PERIOD_MONTHLY_LABEL = "Mensual";

export const LIMIT_PERIOD_CHOICES: Map<string, string> = new Map([
  [LIMIT_PERIOD_YEARLY, LIMIT_PERIOD_YEARLY_LABEL],
  [LIMIT_PERIOD_MONTHLY, LIMIT_PERIOD_MONTHLY_LABEL],
]);

interface TaxPayerElectronicDocumentLimit {
  id?: number;
  taxPayerId?: number;
  limitPeriod?: string;
  limitDes?: number;
  graceAmountDes?: number;
  limitReceipts?: number;
  graceAmountReceipts?: number;
  receiptsUseDesCounter?: boolean;
}

export default TaxPayerElectronicDocumentLimit;
